<template>
    <div class="orderTab-bottom">{{checkWS}}
        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between" v-if="$route.name == 'custom-view'">
            <p>{{$t('order_list')}}</p>
            <div class="justify-content-end">
                <a href="#" @click.prevent="$parent.$parent.maximize('order')"><feather size="12px" type="maximize-2"></feather></a>
                <a href="#" @click.prevent="$parent.$parent.close('order')"><feather size="12px" type="x"></feather></a>
            </div>
        </div>
        <app-pending-order v-if="Object.keys(orderMod).length" :order="orderMod"></app-pending-order>
        <div class="topHead border-bottom d-flex justify-content-between align-items-center">
            <tab-section :order="order"/>
            <div class="arrowToggle d-flex align-items-center">
                <button type="button" class="appButton align-items-left" @click="closeAllTrade()" v-if="$route.name == 'home'">
                   {{$t('close_all_orders')}}
                </button>
                <pagination :totalRecords="EL_ES_ORDER(pendingOrderList).length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'pending' && EL_ES_ORDER(pendingOrderList).length > pageLimit"></pagination>
                <a @click="$parent.$parent.setUpFxaccount = !$parent.$parent.setUpFxaccount" class="arrowToggle-buton ml-3" href="#" v-if="$route.name == 'multi-view'"><feather size="15px" type="chevron-up"></feather> </a>
                <button type="button" title="Maximize / Collapse" class="appButton-r d-flex align-items-center justify-content-between" @click="addRemBodyClass()" v-if="$route.name == 'home'">
                    <feather class="showMin" size="15px" type="maximize-2"></feather>
                    <feather class="showMax d-none" size="15px" type="minimize-2"></feather>
                </button>
            </div>
        </div>
        <div class="responsiveTable scrollbar bottomTable fixedHead" v-if="order == 'pending'">
            <table class="table stickyHead">
                <thead class="border-0" v-if="EL_ES_ORDER(pendingOrderList).length > 0">
                    <tr>
                        <th>{{$t('order_id')}}</th>
                        <th>{{$t('open_time')}}</th>
                        <th>{{$t('sell_buy')}}</th>
                        <th v-if="userSettings.position_size && userSettings.position_size == '1'">{{$t('units')}}</th>
                        <th v-else>{{$t('lots')}}</th>
                        <th>{{$t('instrument')}}</th>
                        <th>{{$t('order_price')}}</th>
                        <th>{{$t('s_slash_l')}}</th>
                        <th>{{$t('trail_s_slash_l')}} </th>
                        <th>{{$t('tp')}}</th>
                        <th>{{$t('proximity')}} </th>
                        <th>{{$t('comment')}} </th>
                        <th>{{$t('action')}} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="list,index in EL_ES_ORDER(pendingOrderList)" v-if="index >= (page - 1)*pageLimit && index < page*pageLimit" :class="{'active-order':modifyOrderID == list.OrderID}">
                        <td>{{list.OrderID}}</td>
                        <!-- <td>{{list.OpenTime | moment('HH:mm:ss - DD-MM-YYYY')}}</td> -->
                        <!-- <td>{{formatDateTime(list.date)}}</td> -->
                        <td>{{formatDateTime(list.OpenTime)}}</td>
                        <td :class="sideClass[list.Side]" v-if="['EL','ES','S','L'].includes(list.Type)">{{sideValue[list.Side] || '-'}} {{ list.Trail?'Trail.':'' }} {{pendingType[list.Type]}}</td>
                        <td v-else>{{pendingType[list.Type]}} {{$t('order')}}</td>
                        <td>{{getQuantity(list) || '0'}}</td>
                        <td>{{list.Symbol}}</td>
                        <td>{{list.Price || '-'}}</td>
                        <td>{{['EL','ES'].includes(list.Type) ? (orderSL_TP(list,'S').Price || '0') : '0' }}</td>
                        <td>{{getTrail(list.OrderID).Trail || (['L','S'].includes(list.Type)?list.Trail:0) || '0'}}</td>
                        <td>{{['EL','ES'].includes(list.Type) ? (orderSL_TP(list,'L').Price || '0') : '0' }}</td>
                        <td>{{Math.abs(getProximity(list,instruments[list.Symbol]))}}</td>
                        <td>{{list.Commentary || '-'}}</td>
                        <td>
                            <span class="d-flex align-items-center justify-content-center" v-if="delOrder.includes(list.OrderID)">
                                <a class="td-button openPendingOrder disabled" href="#"><feather size="12px" type="edit"></feather></a>
                                <a class="td-button closeBtn disabled" href="#" ><feather size="12px" type="x"></feather></a>
                            </span>
                            <span class="d-flex align-items-center justify-content-center" v-else>
                                <a @click.prevent="modifyOrder(list)" class="td-button openPendingOrder" href="#" v-if="['EL','ES'].includes(list.Type)">
                                    <feather size="12px" type="edit"></feather>
                                </a>
                                <!-- <a class="td-button" href="#"><feather size="12px" type="settings"></feather></a> -->     
                                <a class="td-button closeBtn" href="#" @click.prevent="cancleOrder(list)"><feather size="12px" type="x"></feather></a>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="EL_ES_ORDER(pendingOrderList).length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Pending Orders"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import app_pending_order from './modify-order/pending-order-modify'
    import tab_section from './tab-section'
    import { commonAllmixins } from '@/plugins/commonAll'
    import moment from 'moment'
    import { Const } from '@/plugins/vue-provider-cache/const.mod'
export default {
    name: 'order-list',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader: false,
            page : '1',
            sideClass:{
                '0':'red',
                '1':'green',
            },
            sideValue:{
                '0':'Sell',
                '1':'Buy',
            },
            pendingType:{
                'ES':'Stop',
                'EL':'Limit',
                'L':'TakeProfit',
                'S':'StopLoss'
            },
            orderMod:{},
            tempOrderId:[],
            delOrder:[],
        }
    },
    components:{
        tabSection:tab_section,
        appPendingOrder:app_pending_order
    },
    props:{
        pageLimit:{
            type: Number,
            default: 5
        },
        order:{
            default: 'pending'
        },
        modifyOrderID:{
            default: ''
        }
    },
    emits:['modifyOrder'],
    methods:{
        modifyOrder(item){
            if(this.$route.name == 'home'){
                let order = item;
                order['SL'] = this.orderSL_TP(item,'S');
                order['TP'] = this.orderSL_TP(item,'L');
                order['Trail'] = this.getTrail(item.OrderID)
                this.$emit('modifyOrder',order);
            }else{
                this.openMofifyOrder(item,this.orderSL_TP(item,'S'),this.orderSL_TP(item,'L'),(item.Trail || this.getTrail(item.OrderID) || ''))
            }
        },
        closeAllTrade(){
            const _that = this
            
            this.$confirm(
            { message: 'Are you sure you want to close all Orders?',
            button: {
                no: 'No',
                yes: 'Yes'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: confirm => {
                if (confirm) {
                    // ... do something
                    for(var index in _that.EL_ES_ORDER(_that.pendingOrderList)) _that.cancleOrder(_that.pendingOrderList[index]);
                }
            }
            })
        },
        addRemBodyClass(){
            if($(document.getElementsByClassName('maxCollapse')).hasClass('maximizeToggle')){
                $(document.getElementsByClassName('maxCollapse')).removeClass('maximizeToggle')

                $(document.getElementsByClassName('splitTop')).height('calc(100vh - 290px)')

                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 5
                }
            }else{
                $(document.getElementsByClassName('maxCollapse')).addClass('maximizeToggle')
                $(document.getElementsByClassName('splitTop')).height(0)
                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 10
                }
            }
        },
        changeDate(){
            this.filterOption = false
            if(this.dateSelected == '1'){
                this.FROM_DATE = moment(Date.now()).format('YYYY-MM-DD');
                this.TO_DATE = moment(Date.now()).format('YYYY-MM-DD');
            }else if(this.dateSelected == '2'){
                this.FROM_DATE = moment(new Date(Date.now() - 15 * 30*24 * 3600 * 1000)).format('YYYY-MM-DD');
                this.TO_DATE = moment(Date.now()).format('YYYY-MM-DD');
            }else if(this.dateSelected == '3'){
                let d = new Date();
                d.setMonth(d.getMonth() - 1);
                this.FROM_DATE = moment(d).format('YYYY-MM-DD');
                this.TO_DATE = moment(Date.now()).format('YYYY-MM-DD');
            }else if(this.dateSelected == '4'){
                let d = new Date();
                d.setMonth(d.getMonth() - 3);
                this.FROM_DATE = moment(d).format('YYYY-MM-DD');
                this.TO_DATE = moment(Date.now()).format('YYYY-MM-DD');
            }
            this.pendingOrderListing()
        },
        getQuantity(list){
            let lotBy = 100000
            try{
                lotBy = this.currencyPairs.filter(val=>val.isinid.includes( list.Symbol.slice(0,6)))[0].market_ContractSize || 100000
            }catch(e){}
            if(this.userSettings.position_size && this.userSettings.position_size == '1'){
                return list.Quantity
            }else{
                return list.Quantity?(list.Quantity / lotBy):0
            }
        },
        /*getQuantity(list){
            let lotBy = 100000
            try{
                // lotBy = this.currencyPairs.filter(val=>val.isinid.includes(list.Symbol))[0].market_ContractSize || 100000
                lotBy = ((this.instruments[list.Symbol] || {}).other || {}).market_ContractSize || 10000
            }catch(e){
                console.log("ex", e)
            }
            if(this.userSettings.position_size && this.userSettings.position_size == '0'){
                return list.Quantity
            }else{
                return list.Quantity?(list.Quantity / lotBy):0
            }
        },*/
        openMofifyOrder(list,SL,TP,Trail){
            this.orderMod = list
            this.orderMod['SL'] = SL
            this.orderMod['TP'] = TP
            this.orderMod['Trail'] = Trail
        },
        EL_ES_ORDER(list){
            return list/*.filter(val=>['EL','ES'].includes(val.Type))*/
        },
    	getProximity(list,instruments){
    		try{
	    		if(instruments && list.Price){
	    			if(parseInt(list.side) == 1){
	    				return parseFloat(((parseFloat(instruments.B) - list.Price)/parseFloat(instruments.other.pip_size)).toFixed(4))
	    			}else{
	    				return parseFloat(((parseFloat(instruments.A) - list.Price)/parseFloat(instruments.other.pip_size)).toFixed(4))
	    			}
	    		}else{
	    			return 0
	    		}
    		}catch(e){return 0}
    	},
    	orderSL_TP(list,type){
    		try{
    			let close = this.pendingOrderList.filter(val=>(val.ToClose == list.OpenOrderID || val.TradeID == list.OrderID || val.ToClose == list.OrderID || val.OpenOrderID == list.OrderID || val.OpenTime == list.OpenTime) && val.Type == type)
    			return (close.length)?close[0]:{}
    		}catch(e){return {}}
    	},
    	getTrail(TradeID){
    		try{
    			let close = this.pendingOrderList.filter(val=> (val.TradeID == TradeID || val.ToClose == TradeID || val.OpenOrderID == TradeID) && val.Type == 'S')
    			return (close.length)?close[0]:{}
    		}catch(e){return {}}
    	},
        cancleOrder(item){
            const tempOrderId = new Date().getTime()
            if(this.modifyOrderID == item.OrderID){
                this.$emit('modifyOrder',null);
            }
            let orderJson = {
				"order_id" : item.OrderID,
				"tempOrderId" : tempOrderId,
				'localParams':this
			}
            this.delOrder.push(item.OrderID)
            this.tempOrderId.push(tempOrderId)
            // console.log('cancle order data',orderJson)
            this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
				.seeders['S_PF_PF'].cancelOrder(orderJson)
        },
		successWs(){
			// console.log('cancle Order ws')
		},
        failedWs(){
        	this.displayError('There is some network issue','error')
        },
        displayError(getMessage,type){
            this.$notify({
                group: 'foo',
                type: (type && type == null)?'error':type,
                text: getMessage,
                duration: 4000,
                closeOnClick: true
            });
        },
        pendingOrderListing(){
            this._runGetpendingOrderList({ 'globalParams' : {'FROM_DATE' : this.FROM_DATE, 'TO_DATE' : this.TO_DATE ,},'localParams' : { 'parameter' : this } })
        },
    },
    computed:{
        checkWS(){
            let _that = this
            this.tempOrderId.forEach(val=>{
                if(_that.wsOrder.hasOwnProperty(val)){
                    let msg = _that.wsOrder[val].resp_msg
                    let msgType = (_that.wsOrder[val].stat == 'OK')?'success':'error'
                    _that.displayError(msg,msgType)
                    _that.tempOrderId.splice(_that.tempOrderId.indexOf(val), 1)
                }
            })
        },
    	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {
	            return {}
	        }
	    },
    },
    created(){
        if(this.pendingOrderList.length == 0 || this.$route.name == 'custom-view'){
            this.pendingOrderListing()
        }
    },
    mounted() {
        /* const _that = this
        $(document).on("click", function(event){
            if(!$(event.target).closest('.openPendingOrder').length){
                _that.pendingOrder = false
            }
        });*/
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/order-list.vue